// Thin wrapper over the GA4 gtag already loaded in public/index.html (G-4VPWPYEEJB).
// Used to fire funnel events (sign_up, view_programs, begin_checkout, payment_confirmed,
// play_session) so Google Analytics can show where users drop off. Never throws — if
// gtag isn't present (blocked, offline), tracking is silently a no-op.
export const track = (event, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', event, params);
    }
  } catch (_) { /* analytics must never break the app */ }
};
